import styled from '@emotion/styled';
import Media from '@ep/components/Media';
import theme from '@ep/theme';
import { Gcms_Asset } from '@ep/types/gatsbyTypes';
import CloseIcon from '@mui/icons-material/Close';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import 'lazysizes';
import React from 'react';

export interface ModalDialogProps {
  open: boolean;
  setOpen: (state: boolean) => void;
  modalDialogMedia: Gcms_Asset;
}

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseModal = styled.div`
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 10;
`;

const ModalContainer = styled.div`
  outline: none;
`;

function ModalDialog({ open, setOpen, modalDialogMedia }: ModalDialogProps) {
  return (
    <>
      <StyledModal open={open} onClose={() => setOpen(false)}>
        <Fade in={open}>
          <ModalContainer>
            <CloseModal>
              <IconButton aria-label="close" onClick={() => setOpen(false)}>
                <CloseIcon htmlColor={theme.colors.white} />
              </IconButton>
            </CloseModal>
            <Media media={modalDialogMedia} />
          </ModalContainer>
        </Fade>
      </StyledModal>
    </>
  );
}

export default ModalDialog;
